import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import { app } from "@/firebase/config";
import postItem from "@/composables/postItem";
import store from "@/store";

const vapidKey = process.env.VUE_APP_FIREBASE_VAPID_KEY;

const isMessagingReady = async () => {
  return process.env.NODE_ENV === "production" &&
    Boolean(vapidKey) &&
    "Notification" in window &&
    await isSupported();
};

const deviceName = () => {
  const ua = navigator.userAgent || "";
  if (/Edg/i.test(ua)) return "Edge";
  if (/Chrome/i.test(ua)) return "Chrome";
  if (/Safari/i.test(ua)) return "Safari";
  if (/Firefox/i.test(ua)) return "Firefox";
  return "Browser";
};

const registerNotificationToken = async () => {
  if (!store.state.user || !(await isMessagingReady())) {
    return { status: "unavailable" };
  }

  if (Notification.permission === "denied") {
    return { status: "denied" };
  }

  const permission = Notification.permission === "granted"
    ? "granted"
    : await Notification.requestPermission();

  if (permission !== "granted") {
    return { status: permission };
  }

  const registration = await navigator.serviceWorker.ready;
  const messaging = getMessaging(app);
  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: registration,
  });

  if (!token) {
    return { status: "empty" };
  }

  await postItem("notification/tokens", {
    token,
    platform: "web",
    device_name: deviceName(),
  });

  localStorage.setItem("easyhmo_fcm_token", token);

  return { status: "registered", token };
};

const syncNotificationToken = async () => {
  if (Notification.permission !== "granted") {
    return { status: Notification.permission };
  }

  return registerNotificationToken();
};

const revokeNotificationToken = async () => {
  const token = localStorage.getItem("easyhmo_fcm_token");

  if (!token) {
    return;
  }

  await postItem("notification/tokens/revoke", { token });
  localStorage.removeItem("easyhmo_fcm_token");
};

const listenForForegroundMessages = async (callback) => {
  if (!(await isMessagingReady())) {
    return;
  }

  const messaging = getMessaging(app);
  onMessage(messaging, callback);
};

export {
  isMessagingReady,
  listenForForegroundMessages,
  registerNotificationToken,
  revokeNotificationToken,
  syncNotificationToken,
};
